import React from 'react';
import InputBase, { InputBaseProps } from '@material-ui/core/InputBase';
import throttle from 'lodash/throttle';
import { SearchOutlined } from '@material-ui/icons';
import { Box } from '@material-ui/core';
import clsx from 'clsx';

import { useStyles } from './styles';
import { useTheme } from '@material-ui/core';

type SearchProps = Omit<InputBaseProps, 'value'> & {
  value?: string;
  onChange: (value: string) => void;
  containerClass?: string;
};

export const Search: React.FC<SearchProps> = ({ value, onChange, containerClass, ...restProps }) => {
  const [focused, setFocused] = React.useState(false);
  const classes = useStyles();
  const theme = useTheme();

  const wrappedOnChange = throttle((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  }, 200);

  const toggleFocused = () => setFocused(_focused => !_focused);

  return (
    <Box className={clsx(classes.root, { [classes.active]: focused }, containerClass)}>
      <InputBase
        value={value}
        onChange={wrappedOnChange}
        className={classes.textInput}
        onFocus={toggleFocused}
        onBlur={toggleFocused}
        {...restProps}
      />

      <SearchOutlined className={classes.icon} htmlColor={theme.palette.grey['400']} width={24.8} height={24.8} />
    </Box>
  );
};
